import React, {useEffect, useState} from 'react';
import { Button, Paper, Typography } from "@mui/material";
import {
    View,
    Text,
    StyleSheet,
    Dimensions,
    Platform,
    Pressable,
    TextInput
  } from 'react-native';
  import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import Tooltip from '@mui/material/Tooltip';
import CircleIcon from '@mui/icons-material/Circle';

import {Controlled as CodeMirror} from 'react-codemirror2';
require('codemirror/lib/codemirror.css');
require('codemirror/theme/material.css');
require('codemirror/theme/neat.css');
require('codemirror/mode/xml/xml.js');
require('codemirror/mode/javascript/javascript.js');

const DemoPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    height:'auto',
    padding: theme.spacing(2),
    ...theme.typography.body2,
    textAlign: 'center',
  }));

  

  const options={
    mode: 'json',
    theme: 'xq-light',
    lineNumbers: true,
    textAlign:'left'
  }
  
  const LookUpUser =(props:any)=>{
    const [user, setUser]=useState(props.user);
    const [response, setResponse] = useState("");
    const [status, setStatus]=useState(false);
    const [statusText, setStatusText]=useState("");
    const [isSubmit, setIsSubmit]= useState(false);
    var auth= "Basic "+ process.env.REACT_APP_TIGER_AUTHORIZATION ;
 

  const configs = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      authorization: auth
    }
  };

    const handleLookup=()=>{
    fetch('https://developer.tigertext.me/v2/user/'+user, configs)
    .then(res => res.json())
    .then(res =>{
      console.log(res.status);
      setIsSubmit(true);
      if(res.status ==="success"){
        setStatus(true);
        setStatusText("200 - Result");
      }
      else{
        setStatus(false);
        setStatusText("404 - Result");
      }
      setResponse(JSON.stringify(res, null, 2));
    })
    .catch(err => {
      //console.error(err);
      setStatus(false);
      setStatusText("404 - Result");
    });

    };
    const resetLookup=()=>{
      setUser("");
      setIsSubmit(false);
      setResponse("");
    };
    const copyResponse=(e:any)=>{
     // console.log(e);
      navigator.clipboard.writeText(e);
    };
    return(
        <View style={{flexDirection:'row', justifyContent:'flex-start'}}>
          <View style={{width:'35%',marginLeft:20, flexDirection:'column'}}>
                <DemoPaper square={false} style={{marginTop:20,  height:'40%'}}>
                    <View style={{flexDirection:'column', justifyContent:'center'}}>
                      <View style={{height:40, backgroundColor:'#eef2f7', justifyContent:'center', marginBottom:20, flexDirection:'row'}}>
                        <Text style={{textAlign:'center', alignSelf:'center' , fontWeight:'bold', fontSize:18}}>Look up </Text>
                        <Text style={{textAlign:'center', alignSelf:'center', color:'#EA0029', fontWeight:'bold', fontSize:18}}>tigerconnect</Text>
                        <Text style={{textAlign:'center', alignSelf:'center', fontWeight:'bold', fontSize:18}}> user </Text>
                        
                      </View>
                      <View style={{flexDirection:'column', justifyContent:'center'}}>
                      <TextInput  style={{borderWidth:1,maxHeight:200,padding:5, width:'80%', marginRight:10, alignSelf:'center'}} value={user} onChangeText={e=>setUser(e)}/>
                      <View style={{flexDirection:'row', justifyContent:'center', marginTop:20}}>
                      <Button style={{}} onClick={handleLookup} variant={"contained"}>Submit</Button>
                      <Button onClick={() => resetLookup()} variant={"outlined"} style={{marginLeft:20}}>
                                    Reset
                                </Button>
                      </View>
                    
                      </View>
                      </View>
                </DemoPaper>
                
            </View>
            <View style={{width:'55%', marginLeft:30}}>
              <DemoPaper square={false} style={{marginTop:20, marginLeft:20,  height:'auto'}}>
                  <View style={{flexDirection:'row', justifyContent:'flex-start',height:40, backgroundColor:'#eef2f7', padding:10}}>
                    <Text>Response</Text>
                    
                       {isSubmit && <Pressable onPress={()=>copyResponse(response)} style={{marginLeft:'20%', marginRight:'20%'}}>
                            <Tooltip title="copy to clipboard">
                               <ContentPasteIcon />
                            </Tooltip>
                        </Pressable> }
                        {isSubmit &&  <View style={{flexDirection:'row', marginLeft:100,  justifyContent:'center', alignItems:'center'}}>
                      <CircleIcon style={{color: status === true ? '#12ca93':'#EA0029', fontSize:20, paddingRight:5}}/>  
                        <Text style={{textAlign:'center'}}>{statusText}</Text>

                      </View>  }
                       
                    
                  </View>
                  <View style={{justifyContent:'flex-start', alignSelf:'flex-start'}}>
                  <CodeMirror
                      
                      value={response}
                      options={options}
                      onBeforeChange={(editor, data, value) => {
                        setResponse(value);
                      }}
                      onChange={(editor, data, value) => {
                      }}
  />
                  </View>
              </DemoPaper>
            </View>

        </View>
    )
  };
  export default LookUpUser;